<div class="ui basic segment">
  <form
    class="ui form"
    [formGroup]="forgotPasswordForm"
    (ngSubmit)="forgotPassword()"
  >
    <div class="ui basic segment">
      <h3 class="ui header">Forgot Password</h3>
    </div>
    <div
      class="field"
      [class.error]="
        forgotPasswordForm?.controls.email.errors &&
        forgotPasswordForm.get('email').dirty
      "
    >
      <div class="ui large input">
        <input type="text" placeholder="Email" formControlName="email" #email />
      </div>
    </div>
    <div class="ui grid">
      <div
        class="left floated sixteen-wide-mobile sixteen-wide-tablet eight-wide-computer column"
      >
        <button
          class="ui secondary tertiary button"
          (click)="changeLoginView(loginView.LOGIN)"
        >
          Exiting user? Login
        </button>
      </div>
      <div
        class="right floated sixteen-wide-mobile sixteen-wide-tablet five-wide-computer column"
      >
        <button
          class="ui large secondary black right floated button circular fluid"
          [disabled]="!forgotPasswordForm?.valid || email.value === ''"
          [ngClass]="{ 'elastic loading': isSubmitted }"
        >
          Submit
        </button>
      </div>
    </div>
  </form>
</div>
